import { Form, Input, Row, Col } from 'antd';
const { TextArea } = Input;

const CreateFeedbackForm = ({ form }) => {
  return (
    <>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            name={'fullName'}
            label="Ad Soyad:"
            onKeyPress={(e) => {
              if (!/[a-zA-Z wığüşöçĞÜŞÖÇİ]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            rules={[
              {
                required: true,
                message: 'Lütfen geçerli ad soyad giriniz!',
              },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name="email"
            label="E-Posta"
            rules={[
              { type: 'email', message: 'Geçerli bir e-posta giriniz' },
              { required: true, message: 'geçerli bir e-posta giriniz.' },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            name={'message'}
            label="Mesajınız:"
            rules={[
              {
                required: true,
                message: 'Lütfen geçerli mesaj giriniz!',
              },
            ]}
          >
            <TextArea
              autoSize={{
                minRows: 4,
                maxRows: 9,
              }}
              maxLength={1000}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default CreateFeedbackForm;
